import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  projects: [],
  loading: false,
  error: null
};

const validatorProjectSlice = createSlice({
  name: 'validatorProject',
  initialState,
  reducers: {
    setValidatorProjects: (state, action) => {
      state.projects = action.payload;
      state.loading = false;
      state.error = null;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    clearValidatorProjects: (state) => {
      state.projects = [];
      state.loading = false;
      state.error = null;
    }
  }
});

export const {
  setValidatorProjects,
  setLoading,
  setError,
  clearValidatorProjects
} = validatorProjectSlice.actions;

export default validatorProjectSlice.reducer; 